import React from "react";
import { Col, Row } from "react-bootstrap";
import PointersLine from "../Loaders/PointersLine/PointersLine";
import { theme as themeConfig } from "../../themes/themes";
import { ContentMyGames, useStyles } from "./MyGames.styled";
import ListCardMyGames from "../ListCardMyGames";

const MyGames = ({ loadingMyGames, errorMyGames, myGames, goToDetail }) => {
  const classes = useStyles();

  return (
    <ContentMyGames>
      <Row className={classes.containMySpaces}>
        <Col md={12} className={classes.bodyMySpaces}>
          {loadingMyGames && !errorMyGames && (
            <Row>
              <Col
                md="12"
                className="d-flex justify-content-center align-content-center my-5"
              >
                <PointersLine color={themeConfig.text.primary} />
              </Col>
            </Row>
          )}
          {!loadingMyGames && errorMyGames && (
            <Row>
              <Col
                md="12"
                className="d-flex justify-content-center align-content-center my-5"
              >
                <h1 style={{ color: "#ccc" }}>Error :(</h1>
              </Col>
            </Row>
          )}
          {!loadingMyGames && !errorMyGames && (
            <Row className={classes.rowContainMySpaces}>
              {myGames &&
                myGames?.length > 0 &&
                myGames.map((myGame, index) => {
                  return (
                    <>
                      <Col
                        key={index}
                        md={6}
                        className={
                          classes.colCardMySpaces +
                          " " +
                          (index % 2 !== 0 ? classes.rightCard : "")
                        }
                      >
                        <ListCardMyGames
                          goToDetail={goToDetail}
                          myGame={myGame}
                        />
                      </Col>
                    </>
                  );
                })}
            </Row>
          )}
        </Col>
      </Row>
    </ContentMyGames>
  );
};

export default MyGames;
